import { Capacitor } from '@capacitor/core';

export const IS_NATIVE = Capacitor.isNativePlatform();
export const HAS_KEYBOARD = Capacitor.isPluginAvailable('Keyboard');
export const HAS_STATUS_BAR = Capacitor.isPluginAvailable('StatusBar');
export const HAS_SHARE_EXTENSION = Capacitor.isPluginAvailable('ShareExtension');
export const IS_IOS = Capacitor.getPlatform() === 'ios';
